import { TagFacesIcon } from './TagFacesIcon';

/**
 * author: Google
 * id 5DCE0F4D-F740-4D9A-AC93-281D3477E9AF
 * name tag-faces
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tag-faces.svg
 * tags
 */
export const TagEmojiIcon = TagFacesIcon;
export default TagEmojiIcon